import { PageType } from "shared/lib/page-type";

export const pathname = "/video-section";

export const page = {
  route(query: QueryParameters<{ entityId: string; entityUuid: string }>) {
    return {
      pathname,
      query: { ...query, pageType: PageType.VideoSection },
    };
  },
};
